import {
  formatPickupPointAddress,
  formatPickupPointTitle,
  pickupPointIdentifier,
} from './pickupPoint.js'

const mapTemplateId = 'dhl-map-button'
const mapPopupId = 'dhl_popup'
const mapIframeId = 'dhl-map-iframe'
const mapStylesId = 'octolize-dhl-checkout-styles'

const mapTemplateMarkup = `
  <div>
    <button class="btn btn_primary btn_s octolize_dhl_map_button" type="button">
      <h-icon icon-name="icon-map-pin" css-classes="btn__icon btn__icon_left" aria-hidden="true"></h-icon>
      <span class="octolize_dhl_button_label">Wybierz punkt</span>
    </button>
    <div class="octolize_dhl_pickup_point_details" hidden>
      <div class="octolize_dhl_pickup_point_name"></div>
      <div class="octolize_dhl_pickup_point_address"></div>
    </div>
    <label class="octolize_dhl_postnummer" hidden>
      <span class="octolize_dhl_postnummer_label">Postnummer <span class="octolize_dhl_postnummer_required" aria-hidden="true">*</span></span>
      <input class="octolize_dhl_postnummer_input" type="text" inputmode="numeric" autocomplete="off" />
    </label>
  </div>
`.trim()

const mapPopupMarkup = `
  <div id="${mapPopupId}" class="js--popup-dhl" style="display: none;">
    <a href="#0" class="js--popup-close-button-dhl">Zamknij mapę</a>
    <iframe allow="geolocation" id="${mapIframeId}" class="js--popup-dhl-iframe" src=""></iframe>
  </div>
`.trim()

const mapStyles = `
  #${mapPopupId} {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 100000;
    display: none;
    left: 0;
    top: 0;
  }

  #${mapPopupId} > a {
    position: absolute;
    right: 30px;
    color: white;
    top: 20px;
  }

  #${mapIframeId} {
    position: fixed;
    z-index: 100001;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80vw;
    height: 80vh;
    border: none;
  }

  @media screen and (max-width: 768px) {
    #${mapIframeId} {
      width: 90vw;
      height: 85vh;
    }
  }

  .octolize_dhl_pickup_point_details {
    margin-top: 8px;
    font-size: 13px;
    line-height: 1.4;
    color: #4b5563;
  }

  .octolize_dhl_pickup_point_name {
    font-weight: 600;
    color: #111827;
  }

  .octolize_dhl_postnummer {
    display: block;
    margin-top: 8px;
    font-size: 13px;
    line-height: 1.4;
    color: #111827;
  }

  .octolize_dhl_postnummer_label {
    display: block;
    font-weight: 600;
    margin-bottom: 4px;
  }

  .octolize_dhl_postnummer_required {
    color: #b91c1c;
    margin-left: 2px;
  }

  .octolize_dhl_postnummer_input {
    width: 100%;
    max-width: 240px;
    box-sizing: border-box;
    padding: 6px 8px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 13px;
  }
`.trim()

function ensureMapStyles() {
  if (document.getElementById(mapStylesId)) {
    return
  }

  const styleElement = document.createElement('style')
  styleElement.id = mapStylesId
  styleElement.textContent = mapStyles
  document.head.appendChild(styleElement)
}

function ensureMapTemplate() {
  if (document.getElementById(mapTemplateId)) {
    return
  }

  const templateElement = document.createElement('template')
  templateElement.id = mapTemplateId
  templateElement.innerHTML = mapTemplateMarkup
  document.body.appendChild(templateElement)
}

function ensureMapPopup() {
  if (document.getElementById(mapPopupId)) {
    return
  }

  const popupContainer = document.createElement('div')
  popupContainer.className = 'js--popup-container-dhl'
  popupContainer.innerHTML = mapPopupMarkup
  document.body.appendChild(popupContainer)
}

export function ensureCheckoutDom() {
  ensureMapStyles()
  ensureMapTemplate()
  ensureMapPopup()
}

export function getMapPopupElement() {
  return document.querySelector('.js--popup-dhl')
}

export function getMapIframeElement() {
  return document.getElementById(mapIframeId)
}

function getMapButtonLabels() {
  return document.querySelectorAll('.octolize_dhl_button_label')
}

function getPickupPointDetailsElements() {
  return document.querySelectorAll('.octolize_dhl_pickup_point_details')
}

function getPickupPointNames() {
  return document.querySelectorAll('.octolize_dhl_pickup_point_name')
}

function getPickupPointAddresses() {
  return document.querySelectorAll('.octolize_dhl_pickup_point_address')
}

function getPostnummerContainers() {
  return document.querySelectorAll('.octolize_dhl_postnummer')
}

export function getPostnummerInputs() {
  return document.querySelectorAll('.octolize_dhl_postnummer_input')
}

export function setPickupPointPresentation(pickupPoint, isPostnummerRequired) {
  const pointId = pickupPointIdentifier(pickupPoint)

  getMapButtonLabels().forEach((labelElement) => {
    labelElement.textContent = pointId ? `Wybrany punkt: ${pointId}` : 'Wybierz punkt'
  })

  const title = formatPickupPointTitle(pickupPoint)
  const address = formatPickupPointAddress(pickupPoint)

  getPickupPointDetailsElements().forEach((detailsElement) => {
    detailsElement.hidden = !pickupPoint
  })
  getPickupPointNames().forEach((nameElement) => {
    nameElement.textContent = title
  })
  getPickupPointAddresses().forEach((addressElement) => {
    addressElement.textContent = address
  })

  getPostnummerContainers().forEach((containerElement) => {
    containerElement.hidden = !isPostnummerRequired
  })

  const postnummerValue = String(pickupPoint?.postnummer ?? '').trim()
  getPostnummerInputs().forEach((inputElement) => {
    if (document.activeElement !== inputElement) {
      inputElement.value = postnummerValue
    }
  })
}

export function hideMapPopup() {
  const mapPopup = getMapPopupElement()
  const mapIframe = getMapIframeElement()

  if (mapPopup) {
    mapPopup.style.display = 'none'
  }

  if (mapIframe) {
    mapIframe.src = ''
  }
}

export function openMapPopup(mapUrl) {
  const mapPopup = getMapPopupElement()
  const mapIframe = getMapIframeElement()

  if (!mapPopup || !mapIframe) {
    return false
  }

  mapIframe.src = mapUrl
  mapPopup.style.display = 'block'
  return true
}

export function isMapButtonElement(element) {
  return Boolean(element?.closest('.octolize_dhl_map_button'))
}

export function hasMapButtonElement() {
  return document.querySelector('.octolize_dhl_map_button') !== null
}

export function isMapCloseButtonElement(element) {
  return Boolean(element?.closest('.js--popup-close-button-dhl'))
}

export function getPostnummerInputElement(element) {
  return element?.closest('.octolize_dhl_postnummer_input') ?? null
}

export { mapTemplateId }
